"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ImgPreview = function ImgPreview(_ref) {
  var file = _ref.file;
  return /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "image",
    type: file.type,
    src: file.preview,
    alt: file.name
  });
};

var _default = ImgPreview;
exports.default = _default;
ImgPreview.propTypes = {
  file: _propTypes.default.shape({
    preview: _propTypes.default.string,
    name: _propTypes.default.string,
    type: _propTypes.default.string
  })
};
ImgPreview.defaultProps = {
  file: {}
};